// Fullscreen "use a bigger screen" overlay for viewports too narrow for the
// dense Generation/Timeline UI to lay out cleanly. Shown ≤730px wide via a
// pure-CSS media query — no JS resize listener, no React state, no re-renders.

import styles from './SmallScreenGuard.module.css';

export function SmallScreenGuard() {
  return (
    <div className={styles.guard} role="alert" aria-live="polite">
      <div className={styles.card}>
        <i className={`ph-bold ph-device-rotate ${styles.icon}`} />
        <h1 className={styles.title}>VOICE STUDIO</h1>
        <p className={styles.lead}>
          Please use a bigger screen or rotate your device.
        </p>
      </div>
    </div>
  );
}
